export default __webpack_public_path__ + "static/media/Interior (7).6ff97f8d.jpg";